import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Layout/Header';
import { Sidebar } from './components/Layout/Sidebar';
import { Footer } from './components/Layout/Footer';
import { Store } from './pages/Store';
import { AppDetail } from './pages/AppDetail';
import { AllApps } from './pages/AllApps';
import { MyApps } from './pages/MyApps';
import { Create } from './pages/Create';
import { About } from './pages/About';
import { AppSettingsProvider } from './context/AppSettingsContext';
import { FeaturedApps } from './pages/FeaturedApps';
import { MyAccount } from './pages/MyAccount';
import { Settings } from './pages/Settings';
import { HelpSupport } from './pages/HelpSupport';
import { AppStoreListing } from './pages/AppStoreListing';
import { AppInterface } from './pages/AppInterface';
import { Marketing } from './pages/Marketing';
const AppLayout = () => {
  const location = useLocation();
  const showSidebar = location.pathname === '/' || location.pathname === '/apps';
  const isAppInterface = location.pathname.startsWith('/app-interface/');
  const isMarketing = location.pathname === '/marketing';
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-0">
      {!isAppInterface && !isMarketing && <Header data-id="element-1" />}
      <div className="flex flex-1" data-id="element-2">
        {showSidebar && <Sidebar data-id="element-3" />}
        <main className="flex-1 overflow-y-auto" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Store data-id="element-7" />} data-id="element-6" />
            <Route path="/app/:id" element={<AppDetail data-id="element-9" />} data-id="element-8" />
            <Route path="/app-interface/:id" element={<AppInterface data-id="element-11" />} data-id="element-10" />
            <Route path="/apps" element={<AllApps data-id="element-13" />} data-id="element-12" />
            <Route path="/my-apps" element={<MyApps data-id="element-15" />} data-id="element-14" />
            <Route path="/create" element={<Create data-id="element-17" />} data-id="element-16" />
            <Route path="/app-store-listing" element={<AppStoreListing data-id="element-19" />} data-id="element-18" />
            <Route path="/about" element={<About data-id="element-21" />} data-id="element-20" />
            <Route path="/marketing" element={<Marketing data-id="element-23" />} data-id="element-22" />
            <Route path="/featured" element={<FeaturedApps data-id="element-25" />} data-id="element-24" />
            <Route path="/account" element={<MyAccount data-id="element-27" />} data-id="element-26" />
            <Route path="/settings" element={<Settings data-id="element-29" />} data-id="element-28" />
            <Route path="/help" element={<HelpSupport data-id="element-31" />} data-id="element-30" />
          </Routes>
        </main>
      </div>
      {!isAppInterface && !isMarketing && <Footer data-id="element-32" />}
    </div>;
};
export function App() {
  return <Router data-id="element-33">
      <AppSettingsProvider data-id="element-34">
        <AppLayout data-id="element-35" />
      </AppSettingsProvider>
    </Router>;
}